import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast_config } from "../../utils/constants";
import { toast } from "react-toastify";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const AddEventCoordinatorDetails = createAsyncThunk(
  "AddEventCoordinatorDetails",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/CoordinatorManagement/Add-EventCoordinator-Details`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      toast.success("Details added successfully", toast_config);
      return response;
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Failed to add Details",
        toast_config
      );
      return rejectWithValue(error);
    }
  }
);

export const ShowOneCoordinatorDetail = createAsyncThunk(
  "ShowOneCoordinatorDetail",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/CoordinatorManagement/show-CoordinatorDetail/${ID}`
      );
      console.log("res------->", response);
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowCoordinatorProfile = createAsyncThunk(
  "ShowCoordinatorProfile",

  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/CoordinatorManagement/show-CoordinatorProfile/${ID}`
      );
      console.log("res------->", response);
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

// for all Coordinators

export const ShowAllCoordinators = createAsyncThunk(
  "ShowAllCoordinators",
  async (Data, { rejectWithValue }) => {
    console.log(Data);
    try {
      const response = await axios.post(
        `${BASE_URL}/api/v1/CoordinatorManagement/show-Coordinators`,
        Data
      );
      console.log("res------->", response.data.coordinators);
      return response.data.coordinators;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);

export const ShowAllCoordinatorProfiles = createAsyncThunk(
  "ShowAllCoordinatorProfiles",
  async (ID, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/CoordinatorManagement/show-Coordinator-profiles`
      );
      console.log("res------->", response);
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message, toast_config);
      return rejectWithValue(error);
    }
  }
);


export const UpdateCoordinatorEvents = createAsyncThunk(
  "UpdateCoordinatorEvents",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/api/v1/CoordinatorManagement/update-coordinator-events`
      );
      console.log("res------->", response);
      return response.data.data;
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch events", toast_config);
      return rejectWithValue(error);
    }
  }
);


const CoordinatorManagementSlice = createSlice({
  name: "CoordinatorManagementSlice",
  initialState: {
    Data: [],
    IsAdding: false,
    loading: false,
    error: null,
  },
  reducers: {
    IsAddingOpen: (state, action) => {
      state.IsAdding = true;
    },
    IsAddingClose: (state, action) => {
      state.IsAdding = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(AddEventCoordinatorDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddEventCoordinatorDetails.fulfilled, (state, action) => {
        state.loading = false;
      })

      .addCase(ShowOneCoordinatorDetail.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowOneCoordinatorDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload.CoordinatorDetail;
      })

      .addCase(ShowCoordinatorProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowCoordinatorProfile.fulfilled, (state, action) => {
        state.loading = false;

        state.Data = Array.isArray(action.payload.ShowCoordinatorProfile)? action.payload.ShowCoordinatorProfile : [];
      }) 

      .addCase(ShowAllCoordinators.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllCoordinators.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = { ShowCoordinatorProfile: action.payload }; // Fixed Data structure
      })

      .addCase(ShowAllCoordinatorProfiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(ShowAllCoordinatorProfiles.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload.ShowCoordinatorProfile || [];
      })

      .addCase(UpdateCoordinatorEvents.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateCoordinatorEvents.fulfilled, (state, action) => {
        state.loading = false;
        state.Data = action.payload; // Store the response data
        console.log("UpdateCoordinatorEvents API Response:", action.payload); // ✅ Log Response

      })
      

      .addMatcher(
        (action) =>
          action.type.endsWith("/rejected") && action.meta.rejectedWithValue,
        (state, action) => {
          state.loading = false;
          state.error = action.payload.message;
        }
      );
  },
});

export const { IsAddingOpen } = CoordinatorManagementSlice.actions;
export default CoordinatorManagementSlice.reducer;
